import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { fromPlainText } from '@wix/da-editor-tiptap/pkg/components/utils/helpers';
import { AnswerType } from '../../types';

export function useDefaultQuestions() {
  const { t } = useTranslation();
  return useMemo(
    () => [
      {
        id: '1',
        questionBody: fromPlainText(
          t('originalDeviationPopup.questionnaire.defaultQuestions.first')
        ),
        answerType: AnswerType.FREE_TEXT,
        isRequired: true,
      },
      {
        id: '2',
        questionBody: fromPlainText(
          t('originalDeviationPopup.questionnaire.defaultQuestions.second')
        ),
        answerType: AnswerType.MULTIPLE_CHOICE,
        isRequired: true,
        answerChoices: [
          {
            answerText: t(
              'originalDeviationPopup.questionnaire.defaultQuestions.second.answer1'
            ),
            price: 20,
          },
          {
            answerText: t(
              'originalDeviationPopup.questionnaire.defaultQuestions.second.answer2'
            ),
            price: 20,
          },
          {
            answerText: t(
              'originalDeviationPopup.questionnaire.defaultQuestions.second.answer3'
            ),
            price: 20,
          },
        ],
      },
      {
        id: '3',
        questionBody: fromPlainText(
          t('originalDeviationPopup.questionnaire.defaultQuestions.third')
        ),
        answerType: AnswerType.SINGLE_CHOICE,
        isRequired: true,
        answerChoices: [
          {
            answerText: t(
              'originalDeviationPopup.questionnaire.defaultQuestions.third.answer1'
            ),
          },
          {
            answerText: t(
              'originalDeviationPopup.questionnaire.defaultQuestions.third.answer2'
            ),
          },
        ],
      },
    ],
    [t]
  );
}
